import { Grid, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { formatNumber, formatDate } from "../../Utils/utils";
import { Alert } from "@mui/material";
import { useState } from "react";
import { DataTabs } from "../LabTabs";
import { transactionType } from "../../Utils/transactionType";
import {isTestEnv} from "../../globals";
import { useUser } from "../../contexts/UserContext";

export const OpenTransaction = ({ OpenTransaction, OpenTransactionPerBranch, statusError }) => {
  const [expandedPanel, setExpandedPanel] = useState(false);
  const handleChange = (event, isExpanded) => {
    setExpandedPanel(isExpanded);
  };
  const { user } = useUser();
  isTestEnv && console.log("OpenTransaction", OpenTransaction); //542
  isTestEnv && console.log("OpenTransactionPerBranch", OpenTransactionPerBranch); //120

  const dataGridColumns = [
    { field: "IVNUM", headerName: "אסמכתא", cellClassName: "first-column" },
    { field: "FNCNUM", headerName: "מספר תנועת יומן" },
    {
      field: "SUM1",
      headerName: "סכום",
      renderCell: (params) => formatNumber(params.value),
    },
    { field: "DETAILS", headerName: "פרטים" },
    { field: "FNCPATNAME", headerName: "סוג תנועה" },
    {
      field: "FNCDATE",
      type: 'date',
      headerName: "תאריך ערך",
    },
    {
      field: "BALDATE",
      type: 'date',
      headerName: "תאריך למאזן",
    },
    { field: "Y_16227_5_ESHB", headerName: "מספר חברה" },
  ];
  const OTransaction = OpenTransaction?.map((row, index) => ({
    ...row,
    id: index,
    BALDATE: new Date(row["BALDATE"]),
    FNCDATE: new Date(row["FNCDATE"]),
    FNCPATNAME: transactionType[row["FNCPATNAME"]],
  }));

  const OTransPerBranch = OpenTransactionPerBranch?.map((row, index) => ({
    ...row,
    id: index,
    BALDATE: new Date(row["BALDATE"]),
    FNCDATE: new Date(row["FNCDATE"]),
    FNCPATNAME: transactionType[row["FNCPATNAME"]],
  }));
  
  return (
    <Accordion expanded={expandedPanel} onChange={handleChange} disabled={OpenTransaction===null}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: expandedPanel ? "#f0f0f0" : "inherit",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
            }}
          >
            תנועות פתוחות
          </span>
        </div>
      </AccordionSummary>
      {statusError ? (
        <Alert severity="error">אירעה תקלה. נא נסו שנית מאוחר יותר</Alert>
      ) : (OpenTransaction?.length === 0 || (user?.userBranchesList?.length > 0 && OTransPerBranch?.length === 0)) ? (
        <Alert severity="info">אין תנועות פתוחות ללקוח</Alert>
      ) : (
        <div>
          <AccordionDetails
            style={{
              maxHeight: "calc(100vh - 100px)",
              overflowY: "auto",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>
                  {dataGridColumns !== "undefined" && (
                    <DataTabs
                      data={OTransPerBranch}
                      data2={OTransaction}
                      columns={dataGridColumns}
                      TabKey={{value: "BRANCHNAME", label: "סניף"}}
                      hideAllTab={user?.userBranchesList?.length > 0}
                    />
                  )}
                </Typography>
              </Grid>
            </Grid>
          </AccordionDetails>
        </div>
      )}
    </Accordion>
  );
};
